import React, { useCallback } from 'react';

import { ModalWrapper } from '@/components/wrappers';

import EditEmailNotificationModalForm from './EditEmailNotificationModalForm';
import { useEditEmailNotificationModalStore } from './store';

export const EditEmailNotificationModal = () => {
  const handleChangeVisibility = useEditEmailNotificationModalStore((state) => state.handleChangeVisibility);
  const modalVisible = useEditEmailNotificationModalStore((state) => state.modalVisible);

  const handleSetVisible = useCallback(() => {
    handleChangeVisibility(false);
  }, [
    handleChangeVisibility,
  ]);

  return (
    <ModalWrapper
      testId="ModalWrapper"
      visible={modalVisible}
      onSetVisible={handleSetVisible}
      title="Edit Notification"
      // titleBoxStyle={{ paddingBottom: '12px' }}
    >
      <EditEmailNotificationModalForm onCancel={handleSetVisible} />
    </ModalWrapper>
  );
};